import { render, staticRenderFns } from "./TranslateCotainer.vue?vue&type=template&id=7228921a&scoped=true"
import script from "./TranslateCotainer.vue?vue&type=script&lang=js"
export * from "./TranslateCotainer.vue?vue&type=script&lang=js"
import style0 from "./TranslateCotainer.vue?vue&type=style&index=0&id=7228921a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228921a",
  null
  
)

export default component.exports